import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import autobind from 'common/decorators/autobind.js';
import Checkbox from 'core/components/Checkbox.js';
import HealthFundPickerV2 from 'core/components/v2/HealthFundPicker.js';
import Icon from 'core/components/Icon.js';
import {DirectoryStoreContextV2} from 'core/stores/RootStore.js';
import {
    IN_HOSPITAL_NETWORK_FILTER_TEST_ID,
    IN_HOSPITAL_NETWORK_FILTER,
    HOSPITAL_NETWORK_FILTER,
} from 'core/constants.js';
import {
    ButtonV2,
    NotificationV2,
    ToggleV2,
} from '@healthshareau/hs-component-library';

export default
@observer
class HealthFundInfo extends React.Component {
    static contextType = DirectoryStoreContextV2;

    componentDidMount() {
        this.setPromotedGapSchemeId();
    }

    @autobind
    setPromotedGapSchemeId() {
        const {promotedGapSchemes} = this.props;
        const {
            rootStore: {
                healthFundStore: {healthFund, gapSchemeId},
            },
        } = this.context;
        const promotedGapSchemeId = promotedGapSchemes?.find(
            (pgs) => pgs.healthFundId === healthFund?.id,
        )?.gapSchemeId;
        if (!gapSchemeId && promotedGapSchemeId) {
            this.context.updateStore({
                gapSchemeId: promotedGapSchemeId,
                showOnlyGapScheme: false,
            });
        } else if (gapSchemeId && !promotedGapSchemeId) {
            this.context.updateStore({
                gapSchemeId: null,
            });
        }
    }

    @autobind
    toggleCheckbox() {
        this.context.updateStore({
            showOnlyGapScheme: !this.context.showOnlyGapScheme,
            page: 1,
        });
    }

    @autobind
    toggleInNetworkHospitalCheckbox() {
        this.context.updateStore({
            inNetworkHospitalFilter: !this.context.inNetworkHospitalFilter,
            page: 1,
        });
    }

    renderCheckbox() {
        const {
            showOnlyGapScheme,
            promotedGapSchemePractitionerLength,
            rootStore: {
                healthFundStore: {gapSchemeId},
            },
        } = this.context;
        if (gapSchemeId && promotedGapSchemePractitionerLength) {
            return (
                <ul className="options">
                    <li>
                        <label>
                            <input
                                checked={showOnlyGapScheme}
                                onChange={this.toggleCheckbox}
                                type="checkbox"
                            />
                            <Icon name="checkbox" />
                            {
                                'Only show practitioners offering guaranteed no gap options'
                            }
                        </label>
                    </li>
                </ul>
            );
        }
        return null;
    }

    renderInNetworkHospitalCheckbox() {
        const {
            inNetworkHospitalFilter,
            rootStore: {
                healthFundStore: {healthFund, healthFundThemeColor},
                paramStore: {hasSkin},
            },
        } = this.context;

        return (
            <>
                <NotificationV2
                    customClass="in-network-filter-v2"
                    colorTheme={hasSkin && healthFundThemeColor}
                    htmlText={healthFund?.inNetworkPractitionerInformation}
                    children={
                        <ToggleV2
                            dataTestId={IN_HOSPITAL_NETWORK_FILTER_TEST_ID}
                            gaObjectType={HOSPITAL_NETWORK_FILTER}
                            gaSelector={IN_HOSPITAL_NETWORK_FILTER}
                            colorTheme={hasSkin && healthFundThemeColor}
                            customClass={'in-network-filter-button-v2'}
                            text={'Find in hospital network'}
                            icon={'shield'}
                            checked={inNetworkHospitalFilter}
                            onClick={this.toggleInNetworkHospitalCheckbox}
                        />
                    }
                />
            </>
        );
    }

    @autobind
    async selectHealthFundHandler(fund) {
        this.context.updateStore({
            page: 1,
        });
        await this.context.rootStore.healthFundStore?.selectHealthFund(
            fund?.id || 0,
        );
        this.setPromotedGapSchemeId();
    }

    render() {
        const {
            specialty: {isMedical},
            rootStore: {
                paramStore: {hasSkin, isClient, isHfWidget},
                healthFundStore: {healthFunds, healthFund},
            },
        } = this.context;

        const isHFInfoHidden =
            (hasSkin && !isClient) || healthFunds?.length === 0;
        if (isHFInfoHidden) {
            if (healthFund?.inNetworkHospitalInformation) {
                return (
                    <form aria-selected={!!healthFund?.id}>
                        {this.renderInNetworkHospitalCheckbox()}
                    </form>
                );
            } else {
                return null;
            }
        }

        return (
            <HealthFundPickerV2
                gaObjectType={HOSPITAL_NETWORK_FILTER}
                handleSelectHealthFund={(e) => this.selectHealthFundHandler(e)}
                initialOptionText={"I don't have private health insurance"}
                isHidden={isHfWidget}
                stopAutoScroll={true}
            />
        );
    }
}
